"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Log$ = void 0;
/* eslint-disable no-console */
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
/**
 * Property Decorator: Logs an observables newly set value
 * ```
 * \@Log$ public myObservable: Observable<any>;
 * ```
 */
// eslint-disable-next-line @typescript-eslint/ban-types, id-blacklist
function Log$(target, propertyKey) {
    let propertyValue;
    // Called when the property itself is called
    function getter() {
        return propertyValue;
    }
    // Called as soon as a value is set
    function setter(value) {
        if (value instanceof rxjs_1.Observable) {
            propertyValue = value.pipe((0, operators_1.tap)((next) => {
                const isArrayOfObjects = Array.isArray(next) && typeof next[0] === "object";
                const logType = isArrayOfObjects ? "table" : "log";
                console.groupCollapsed(propertyKey);
                console[logType](next);
                console.groupEnd();
            }));
        }
        else {
            propertyValue = value;
        }
    }
    Object.defineProperty(target, propertyKey, {
        get: getter,
        set: setter,
        enumerable: true,
        configurable: true
    });
}
exports.Log$ = Log$;
